module.exports = __webpack_public_path__ + "static/media/hospital-card-4.012b246a.png";